import React from 'react';
import ApplicantChecklistToggle from '../LeaseApplicationTab/ApplicantChecklistToggle';
import { filterApplicants } from '../LeaseApplicationTab/index';
import type { DecisionStatus } from '../../ApplicationProfile/types';

type Props = {
  intl: Object,
  currentRecord: Object,
  applicationDecisionStatus: Array<DecisionStatus>,
  handleChecklistOptionChange?: Function,
  handleEditApplicationForm: Function,
  approveApplicant?: Function,
  cancelApplicant?: Function,
  isResident?: boolean,
  isCanceled?: boolean,
  deniedReasons?: any,
  enabled?: boolean,
  leaseExecuted?: boolean,
  leaseSentToPortal?: boolean,
};

const ApplicationChecklist = ({
  applicationDecisionStatus,
  approveApplicant,
  cancelApplicant,
  currentRecord,
  deniedReasons,
  handleChecklistOptionChange,
  handleEditApplicationForm,
  intl,
  isCanceled,
  isResident,
  leaseExecuted,
  leaseSentToPortal,
  affordaPortaV1,
}: Props) => {
  const applicantsChecklist = filterApplicants(currentRecord.applicants);
  return (
    <>
      {applicantsChecklist.map((applicant) => (
        <ApplicantChecklistToggle
          key={applicant.id}
          applicant={applicant}
          intl={intl}
          applicationDecisionStatus={applicationDecisionStatus}
          handleChecklistOptionChange={handleChecklistOptionChange}
          handleEditApplicationForm={handleEditApplicationForm}
          isResident={isResident}
          deniedReasons={deniedReasons}
          approveApplicant={approveApplicant}
          cancelApplicant={cancelApplicant}
          isCanceled={isCanceled}
          leaseExecuted={leaseExecuted}
          leaseSentToPortal={leaseSentToPortal}
          affordaPortaV1={affordaPortaV1}
        />
      ))}
    </>
  );
};

export default ApplicationChecklist;
